import loadable from '@loadable/component'
import { useParams } from 'react-router'

import CorporateEventLayout from './components/CorporateEventLayout'
import { LocaleAwareSwitch } from 'components/App/Routes/LocaleAwareRoute'
import TrackedRoute from 'components/App/Routes/TrackedRoute'

const CorporateEventLandingPage = loadable(() => import('./pages/CorporateEventLandingPage'))
const CorporateEventFAQPage = loadable(() => import('./pages/CorporateEventFAQPage'))
const CorporateEventOtherActivitiesPage = loadable(() => import('./pages/CorporateEventOtherActivitiesPage'))
const CorporateEventFlightsPage = loadable(() => import('./pages/CorporateEventFlightsPage'))
const CorporateEventAccommodationPage = loadable(() => import('./pages/CorporateEventAccommodationPage'))
const CorporateEventThingsToKnowPage = loadable(() => import('./pages/CorporateEventThingsToKnowPage'))
const CorporateEventRegistrationPage = loadable(() => import('./pages/CorporateEventRegistrationPage'))

function CorporateEventRoutes() {
  const { eventId, regionCode } = useParams<{ eventId: string; regionCode: string }>()

  return (
    <CorporateEventLayout eventId={eventId} regionCode={regionCode}>
      <LocaleAwareSwitch>
        <TrackedRoute exact path="/:regionCode/corporate-events/:eventId" component={CorporateEventLandingPage} />
        <TrackedRoute exact path="/:regionCode/corporate-events/:eventId/faq" component={CorporateEventFAQPage} />
        <TrackedRoute exact path="/:regionCode/corporate-events/:eventId/other-activities" component={CorporateEventOtherActivitiesPage} />
        <TrackedRoute exact path="/:regionCode/corporate-events/:eventId/flights" component={CorporateEventFlightsPage} />
        <TrackedRoute exact path="/:regionCode/corporate-events/:eventId/accommodation" component={CorporateEventAccommodationPage} />
        <TrackedRoute exact path="/:regionCode/corporate-events/:eventId/things-to-know" component={CorporateEventThingsToKnowPage} />
        <TrackedRoute exact path="/:regionCode/corporate-events/:eventId/register" component={CorporateEventRegistrationPage} />
      </LocaleAwareSwitch>
    </CorporateEventLayout>
  )
}

export default CorporateEventRoutes
